module.exports = __webpack_public_path__ + "img/6.294ea030.jpg";